import { CONTENT_TYPE } from '../../enums';
import { mslpForm } from './mslp.schema';
import { blogForm } from './blog.schema';
import { otherForm } from './other.schema';

const contentTypeSchemas = {
  [CONTENT_TYPE.MSLP.value]: mslpForm,
  [CONTENT_TYPE.BLOG.value]: blogForm,
  [CONTENT_TYPE.OTHER.value]: otherForm
};
export const getFormSchema = (contentType) => contentTypeSchemas[contentType];
